import { MainMenuItemsProps } from "./props";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  IconName,
  IconLookup,
  IconDefinition,
  findIconDefinition,
} from "@fortawesome/fontawesome-svg-core";
import { Box, ListItem, UnorderedList, Text, Flex } from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import {
  getIconActiveColor,
  getIconColor,
  getMenuItemBackground,
  getSidebarBackground,
  menutItemPolColor,
} from "utils/uiconfighelper";

export default function MainMenuItem({ item }: { item: MainMenuItemsProps }) {
  const { label, icon, subItems = [], path } = item;
  const { pathname } = useLocation();
  const active = pathname.indexOf(path) > -1;

  const { user } = useTenant();

  const iconLookup: IconLookup = {
    prefix: "far",
    iconName: icon as IconName,
  };
  const iconDefinition: IconDefinition = findIconDefinition(iconLookup);

  const getBackgroundColor = (user: any, active: any) => {
    return active
      ? getMenuItemBackground(user) //if it is active
        ? getMenuItemBackground(user)
        : "#E0E0E0"
      : getSidebarBackground(user)
      ? getSidebarBackground(user) //if it is not on the active : white  (for : custom)
      : "white";
  };

  const getLocalIconColor = (user: any, active: any) => {
    return active
      ? getSidebarBackground(user)
        ? getIconActiveColor(user) //if it is active : white  (for custom) => L&B : white   // others : #6200FF
        : "#2E2C32"
      : getSidebarBackground(user)
      ? getIconColor(user) //if it is not on the active : #2E2C32  (for : custom) => L&B : white
      : "#2E2C32";
  };

  const getTextColor = (user: any, active: any) => {
    return active
      ? getMenuItemBackground(user)
        ? getIconActiveColor(user)
        : "#2E2C32"
      : getMenuItemBackground(user)
      ? getIconColor(user)
      : "#2E2C32";
  };

  return (
    <ListItem
      borderTopLeftRadius="7px"
      borderBottomLeftRadius="7px"
      bg={getBackgroundColor(user, active)}
      borderRightWidth={active ? "4px" : "0px"}
      borderRightColor={menutItemPolColor(user)}
    >
      <Link to={path} data-cy={item.cy}>
        <Flex py="12px" px="16px">
          <Box w="20px" h="20px" mr="18px">
            {icon && (
              <FontAwesomeIcon icon={iconDefinition} color={getLocalIconColor(user, active)} />
            )}
          </Box>
          <Text fontWeight="500" fontSize="15px" color={getTextColor(user, active)}>
            {label}
          </Text>
        </Flex>
      </Link>
      {active && !!subItems.length && (
        <UnorderedList pl="54px" pb="10px" listStyleType="none" m="0" w="100%">
          {subItems.map(item => (
            <ListItem
              key={item.path}
              color={item.path === pathname ? "primary" : "black"}
              fontSize="13px"
              lineHeight="21px"
              fontWeight="500"
              py="5px"
            >
              <Link to={item.path}>{item.label}</Link>
            </ListItem>
          ))}
        </UnorderedList>
      )}
    </ListItem>
  );
}
